<template>
  <!-- eslint-disable -->
  <v-dialog v-model="opened">
    <v-card>
      <v-card-title>
        <slot name="dialogHeader"></slot>
      </v-card-title>
      <v-card-text>
        <slot name="dialogBody"></slot>
      </v-card-text>
      <v-card-actions>
        <slot name="dialogFooter"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    opened: {
      type: Boolean,
      required: false,
      default: false,
    },
  }, // props
};
</script>
